import React from "react"
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { onKeyDown } from "../../../service";
import classes from "./HomePageBanner.module.css";

const HomePageBanner = ({ title, subTitle, btnText, link }) => {

    const user = useSelector((state) => state.auth.user);
    const { logo } = useSelector(state => state.application);
    const direction = useSelector(state => state.translate.direction);
    const navigate = useNavigate();

    return <div className={`${classes[direction]} ${classes.HomePageBanner}`} >
        <div className={classes.MsgTxt} >
            <div className={classes.LogoIcon} style={{ backgroundImage: `url(${logo})` }}></div>
            <h1 className={classes.WelUserTxt} >{title} {user.firstName} {user.lastName}</h1>
            <h2 className={classes.AssignmentsTxt} >{subTitle}</h2>
            <div className={classes.AssignmentsBtn} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => window.location.href = link)} onClick={() => window.location.href = link} >{btnText}</div>
        </div>
    </div>
}

export default HomePageBanner;